import { render, staticRenderFns } from "./render-profile-column-value.vue?vue&type=template&id=f65c6cce"
import script from "./render-profile-column-value.vue?vue&type=script&lang=js"
export * from "./render-profile-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f65c6cce')) {
      api.createRecord('f65c6cce', component.options)
    } else {
      api.reload('f65c6cce', component.options)
    }
    module.hot.accept("./render-profile-column-value.vue?vue&type=template&id=f65c6cce", function () {
      api.rerender('f65c6cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-profile-column-value.vue"
export default component.exports